import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../css/Setup.css';

export default function Setup({ isNavOpen }) {
  const { t } = useTranslation();

  return (
    <div className={isNavOpen ? 'body-squeezed' : 'body'}>
      <div className="setup-container">
        <div className='setup-card-wrapper'>
          <div className="setup-card">
            <h3 className="setup-card-title">
              {t('Setup.title')}
            </h3>

            <p className="setup-subtitle">
              {t('Setup.subtitle')}
            </p>

            <div className="setup-price">
              <span className="setup-price-old">
                {t('Setup.price.original')}
              </span>
              <span className="setup-price-free">
                {t('Setup.price.free')}
              </span>
            </div>

            <ul className="setup-features">
              <li>{t('Setup.features.feature1')}</li>
              <li>{t('Setup.features.feature2')}</li>
              <li>{t('Setup.features.feature3')}</li>
              <li>{t('Setup.features.feature4')}</li>
              <li>{t('Setup.features.feature5')}</li>
              <li>{t('Setup.features.feature6')}</li>
              <li>{t('Setup.features.feature7')}</li>
              <li>{t('Setup.features.feature8')}</li>
              <li>{t('Setup.features.feature9')}</li>
            </ul>

            <div className="setup-onboarding">
              <h4>{t('Setup.onboarding.title')}</h4>
              <p>{t('Setup.onboarding.description')}</p>

              <ul>
                {t('Setup.onboarding.items', { returnObjects: true }).map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>

              <p className="setup-onboarding-note">
                {t('Setup.onboarding.note')}
              </p>
            </div>

            <div className="setup-cta">
              <Link to="/start" className="get-started-button">
                {t('Home.navbar.getStarted')}
              </Link>
            </div>


          </div>
        </div>
      </div>
    </div>
  );
}
